// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import LeftSquareTwoToneSvg from "@fishx/icons-svg/es/asn/LeftSquareTwoTone";
import FishxIcon from '../components/FishxIcon';

var LeftSquareTwoTone = function LeftSquareTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: LeftSquareTwoToneSvg
  }));
};

LeftSquareTwoTone.displayName = 'LeftSquareTwoTone';
export default React.forwardRef(LeftSquareTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/LeftSquareTwoTone.js
// module id = 3034
// module chunks = 0